import { render, staticRenderFns } from "./CcrisItems.vue?vue&type=template&id=0a335abe"
import script from "./CcrisItems.vue?vue&type=script&lang=js"
export * from "./CcrisItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports